const init = () => {
    $(document).ready(function () {
      $('.clamp-content').css('-webkit-box-orient', 'vertical');

      $('.toggleButton').on('click', function (event) {
        const toggleButton = $(this);
        const contentBlock = toggleButton.closest('.container-fluid').find('.clamp-content');

        if (contentBlock.hasClass('clamp-text')) {
            contentBlock.removeClass('clamp-text');
            toggleButton.text('Read Less');
            contentBlock.css('-webkit-box-orient', 'unset');
        } else {
            contentBlock.addClass('clamp-text');
            toggleButton.text('Read More');
            contentBlock.css('-webkit-box-orient', 'vertical');
        }
      });
  });
};

export {
  init
}
